module.exports = __webpack_public_path__ + "static/media/marketplaceBackground.47d4586f.jpeg";